export function formatNumber(num: number | string): string {
  if (typeof num === 'string') {
    num = parseFloat(num);
  }
  return num.toLocaleString('en-US', { maximumFractionDigits: 2 });
}

export function formatLargerNumber(number: number): string {
  if (number < 10000) {
    return number.toString();
  }
  if (number >= 10000 && number < 1_000_000) {
    return (number / 10000).toFixed(1) + 'K';
  }
  if (number >= 1_000_000 && number < 1_000_000_000) {
    return (number / 1_000_000).toFixed(1) + 'M';
  }
  if (number >= 1_000_000_000 && number < 1_000_000_000_000) {
    return (number / 1_000_000_000).toFixed(1) + 'B';
  }
  return (number / 1_000_000_000_000).toFixed(1) + 'T';
}
